'use strict';

function recordKey(event) {
  const r = event && event.record ? event.record : {};
  return `${event.type}:${r.kind || ''}:${r.id ?? r.pay_app_id ?? ''}`;
}

/** Keep the first of same-type/same-record events within windowMs (default 60s). */
function collapseEvents(events, windowMs = 60_000) {
  const out = [];
  for (const e of events || []) {
    const prev = out[out.length - 1];
    if (!prev) {
      out.push(e);
      continue;
    }
    const dt = Math.abs((Date.parse(e.occurred_at) || 0) - (Date.parse(prev.occurred_at) || 0));
    if (recordKey(prev) === recordKey(e) && dt <= windowMs) continue;
    out.push(e);
  }
  return out;
}

export { collapseEvents, recordKey };
